module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_landing_4_.5caa948a.png";